import React from 'react';
import { connect } from 'react-redux';

import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';
import FormulaSettings from './FormulaSettings';
import TargetSettings from './TargetSettings';

const AllowanceDeductionFormula = ({ useYearEndAdjustment }) => (
  <div>
    {!useYearEndAdjustment && <FormulaSettings />}
    <TargetSettings allowanceType="deduction" />
  </div>
);

export default connect(state => ({
  useYearEndAdjustment: selector(getAllowanceFormValues(state), 'useYearEndAdjustment')
}))(AllowanceDeductionFormula);
